import { message } from 'antd';

const Notification_Duration = 2;
export const showSuccessNotification = (content: string) => {
  message.success(content, Notification_Duration);
};

export const showInfoNotification = (content: string) => {
  message.info(content, Notification_Duration);
};
